// DOM handles shared by every module.

const $=id=>document.getElementById(id);
const cv=$('cv'),wrap=$('wrap');

export { $, cv, wrap };
